var _rect, _path, _path2, _path3, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 79.9993,
    height: 80,
    rx: 39.9996,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8037 60.472C56.3849 60.4727 55.9702 60.3897 55.5839 60.2278C55.1977 60.066 54.8477 59.8285 54.5545 59.5295L20.9321 25.9294C20.3906 25.3203 20.1027 24.5271 20.1274 23.7125C20.1522 22.898 20.4876 22.1237 21.065 21.5485C21.6424 20.9733 22.418 20.6408 23.2328 20.6191C24.0476 20.5973 24.8398 20.8881 25.4471 21.4317L59.0529 55.0318C59.4962 55.4781 59.7977 56.0453 59.9196 56.6624C60.0415 57.2794 59.9783 57.9186 59.738 58.4999C59.4977 59.0811 59.091 59.5784 58.5689 59.9293C58.0469 60.2801 57.4328 60.469 56.8037 60.472Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.806 41.1318C56.387 41.1306 55.9725 41.0467 55.5861 40.8847C55.1997 40.7228 54.8491 40.4861 54.5545 40.1882L40.3008 25.9352C39.7036 25.3381 39.3682 24.5283 39.3682 23.6839C39.3682 22.8395 39.7036 22.0296 40.3008 21.4325C40.8979 20.8354 41.7078 20.5 42.5522 20.5C43.3967 20.5 44.2066 20.8354 44.8037 21.4325L59.0575 35.6855C59.3558 35.9797 59.5927 36.3302 59.7544 36.7167C59.916 37.1032 59.9993 37.5179 59.9993 37.9369C59.9993 38.3558 59.916 38.7706 59.7544 39.1571C59.5927 39.5435 59.3558 39.894 59.0575 40.1882C58.7651 40.4891 58.415 40.7278 58.0281 40.8899C57.6412 41.0521 57.2255 41.1343 56.806 41.1318Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4378 60.4999C37.0189 60.4988 36.6043 60.4148 36.2179 60.2529C35.8315 60.091 35.4809 59.8543 35.1864 59.5564L20.9326 45.3034C20.6369 45.0077 20.4024 44.6567 20.2424 44.2705C20.0823 43.8842 20 43.4702 20 43.052C20 42.6339 20.0823 42.2199 20.2424 41.8336C20.4024 41.4473 20.6369 41.0963 20.9326 40.8007C21.2283 40.505 21.5793 40.2705 21.9656 40.1105C22.3519 39.9505 22.7659 39.8682 23.1841 39.8682C23.6022 39.8682 24.0162 39.9505 24.4025 40.1105C24.7888 40.2705 25.1399 40.505 25.4355 40.8007L39.6893 55.0537C39.9876 55.3478 40.2245 55.6983 40.3862 56.0848C40.5479 56.4713 40.6311 56.8861 40.6311 57.305C40.6311 57.724 40.5479 58.1387 40.3862 58.5252C40.2245 58.9117 39.9876 59.2622 39.6893 59.5564C39.397 59.8573 39.0469 60.0959 38.66 60.2581C38.273 60.4202 37.8573 60.5025 37.4378 60.4999Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4959_3795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1429 76.5001C61.1429 77.7629 62.1657 78.7858 63.4286 78.7858H72.5714C73.8343 78.7858 74.8571 77.7629 74.8571 76.5001V62.7858H61.1429V76.5001ZM76 59.3572H72L70.8571 58.2144H65.1429L64 59.3572H60V61.6429H76V59.3572Z",
    fill: "#C00F00"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 78.9993,
    height: 79,
    rx: 39.4996,
    stroke: "black",
    strokeOpacity: 0.12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4959_3795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(56 56.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDelete);
export default __webpack_public_path__ + "static/media/logo-delete.ad147857ce4c4d4b6cdfb0e34c6107e1.svg";
export { ForwardRef as ReactComponent };